import { render, staticRenderFns } from "./ProgramFaqCard.vue?vue&type=template&id=4031e1cf&"
import script from "./ProgramFaqCard.vue?vue&type=script&lang=js&"
export * from "./ProgramFaqCard.vue?vue&type=script&lang=js&"
import style0 from "./ProgramFaqCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports